"use client";

import { useEffect } from "react";
import { initializeGtagEventListeners } from "../utils/gtagEventHandler";
import { setupLazyLoading } from "../utils/setupLazyLoading";
import { CampaignTracking } from "../utils/CampaignTracking";

export function BrowserEventSetup() {
  useEffect(() => {
    initializeGtagEventListeners();
    setupLazyLoading();
    CampaignTracking.init();
  }, []);

  return null;
}
